import { Component, Input } from '@angular/core';
import { User } from '@base/src/app/pages/configuration/panel/configuration.component';

@Component({
  selector: 'app-config-reset-user-password',
  templateUrl: './config-reset-user-password.component.html',
  styleUrls: ['./config-reset-user-password.component.scss'],
})
export class ConfigResetUserPasswordComponent {
  @Input() value!: User;
}
